import { DEFAULT_FLOWCODE_NICKNAME } from '../../../../../constants/flowcode'
import { FC } from 'react'
import { FlowcodeType } from '@dtx-company/inter-app/src/types/flowcode'
import { ModalTypes } from '@dtx-company/inter-app/src/redux/slices/modal'
import { RootCodeState } from '@dtx-company/inter-app/src/redux/types'
import { SelectFlowcodeModalProps } from '../../../../modals/SelectFlowcodeModal/SelectFlowcodeModal.types'
import { TemplatesFlowcodeBtn } from '../../../TemplatesFlowcodeBtn/TemplatesFlowcodeBtn'
import { getIdFromEncodedString } from '@dtx-company/true-common/src/utils/strings'
import {
  setSelectedFlowcode,
  setSelectedTemplateFlowcode
} from '@dtx-company/inter-app/src/redux/slices/printStoreApiSlice/printStoreSlice'
import { useCodeSelector } from '@dtx-company/inter-app/src/hooks/useCodeSelector'
import { useDispatch } from 'react-redux'
import { useModal } from '@dtx-company/inter-app/src/redux/slices/utils'
import dynamic from 'next/dynamic'
import events from '@dtx-company/inter-app/src/event-tracking/events/printStore'

const SelectFlowcodeModal = dynamic<SelectFlowcodeModalProps>(() =>
  import('../../../../../components/modals/SelectFlowcodeModal').then(
    mod => mod.SelectFlowcodeModal
  )
)

export const FlowcodeInput: FC = () => {
  const dispatch = useDispatch()
  const { setOpen, setClose, modalOpen } = useModal(ModalTypes.SELECT_FLOWCODE_MODAL)

  const { selectedTemplateFlowcode } = useCodeSelector((state: RootCodeState) => state.printStore)

  const onClickCreateFlowcode = (): void => {
    events.PrintTemplates_Templates_Brand_Kit_Clicked_Create_Flowcode()
  }

  const onClickEmptyCreateFlowcode = (): void => {
    setClose()
    onClickCreateFlowcode()
  }

  const onFlowcodeSelected = (flowcode: FlowcodeType): void => {
    dispatch(setSelectedFlowcode(flowcode))
    dispatch(setSelectedTemplateFlowcode(flowcode))
    const flowcodeId = getIdFromEncodedString(flowcode.id)
    setClose()
    events.PrintTemplates_Templates_Brand_Kit_Selected_Flowcode({ flowcodeId })
  }

  const onFlowcodeRemoved = (): void => {
    dispatch(setSelectedFlowcode(undefined))
    dispatch(setSelectedTemplateFlowcode(undefined))
    events.PrintTemplates_Templates_Brand_Kit_Removed_Flowcode({
      flowcodeId: selectedTemplateFlowcode?.id
    })
  }

  const onClickSelectFlowcode = (): void => {
    events.PrintTemplates_Templates_Brand_Kit_Clicked_Select_Flowcode()
    selectedTemplateFlowcode ? onFlowcodeRemoved() : setOpen()
  }

  return (
    <>
      <TemplatesFlowcodeBtn
        onClickSelectFlowcode={onClickSelectFlowcode}
        onClickCreateFlowcode={onClickCreateFlowcode}
        onFlowcodeRemoved={onFlowcodeRemoved}
        hasSelectedFlowcode={Boolean(selectedTemplateFlowcode)}
        displayValue={selectedTemplateFlowcode?.nickname || DEFAULT_FLOWCODE_NICKNAME}
      />

      {modalOpen && (
        <SelectFlowcodeModal
          title="Select a Flowcode to print"
          open={modalOpen}
          onClose={setClose}
          onSelectFlowcode={onFlowcodeSelected}
          emptyStateText="You haven’t created any Flowcodes yet. Create a Flowcode to get started and we’ll place it in your order."
          emptyStateOnClickCreateFlowcode={onClickEmptyCreateFlowcode}
        />
      )}
    </>
  )
}
